const SELECTORS = {
  BASES: 'html, body',
  MODAL: '[data-modal-id]',
  BTN_CLOSE: '[data-close-modal-id]',
  MODAL_CONTENT: '.modal__content',
  MODAL_INNER: '.modal__inner',
}

const CLASSES = {
  NO_SCROLL: 'not-scrollable',
  MODAL_VISIBLE: 'modal--is-visible',
  MODAL_TALL_CONTENT: 'modal__inner--has-tall-content',
}

const KEYCODE_ESC = 27

const EVENTS = {
  MODAL_OPEN: 'modal:open',
  MODAL_CLOSE: 'modal:close',
}

let $bases = $(SELECTORS.BASES)

export function init() {

  $(SELECTORS.BTN_CLOSE).on('click', (event, data = {}) => {
    const id = data.id || $(event.currentTarget).attr('data-close-modal-id')
    close(id)
  })

  $(document).on('keyup', (event) => {
    if (event.which === KEYCODE_ESC) {
      const id = $(`.${CLASSES.MODAL_VISIBLE}`).attr('data-modal-id')
      const $matchedModalCloseBtn = $(SELECTORS.BTN_CLOSE).filter(`[data-close-modal-id=${id}]`)
      $matchedModalCloseBtn.trigger('click', {id})
    }
  })
}

export function open(id) {
  if (typeof id === 'undefined') {
    console.warn('open() requires an id (modal.js)')
    return
  }

  const $matchedModal = $(`[data-modal-id="${id}"]`)
  const media = $matchedModal.attr('data-media')

  $matchedModal.addClass(CLASSES.MODAL_VISIBLE)
  $bases.addClass(CLASSES.NO_SCROLL)

  const contentHeight = $matchedModal.find(SELECTORS.MODAL_CONTENT).height()
  const modalHeight = $matchedModal.find(SELECTORS.MODAL_INNER).height()

  if (contentHeight > modalHeight && media !== 'video') {
    $matchedModal.find(SELECTORS.MODAL_INNER).addClass(CLASSES.MODAL_TALL_CONTENT)
  }

  setTimeout(() => {
    $matchedModal.on('click', (event) => {
      const contentInteraction = ($(event.target).closest('.js-modal-content').length || $(event.target).closest('.video-js').length)
      if (contentInteraction) {
        return
      }

      const id = $(event.currentTarget).attr('data-modal-id')
      close(id)
    })
  }, 100)

  $(document).trigger(EVENTS.MODAL_OPEN, {id, media})
}

export function close(id) {
  if (typeof id === 'undefined') {
    console.warn('close() requires an id (modal.js)')
    return
  }

  const $matchedModal = $(SELECTORS.MODAL).filter(`[data-modal-id=${id}]`)
  const media = $matchedModal.attr('data-media')

  $matchedModal.removeClass(CLASSES.MODAL_VISIBLE)
  $bases.removeClass(CLASSES.NO_SCROLL)

  $matchedModal.off('click')
  $(document).trigger(EVENTS.MODAL_CLOSE, {id, media})
}



// WEBPACK FOOTER //
// ./modal.js